import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./style.css";

const sections = [
  { id: "AboutUs", key: "menu.about" },
  { id: "Services", key: "menu.services" },
  { id: "Partners", key: "menu.partners" },
  { id: "Contacts", key: "menu.contacts" },
];

const Navbar = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState(sections[0].id);
  const [isOpen, setIsOpen] = useState(false);

  // следим за скроллом
  useEffect(() => {
    const handleScroll = () => {
      let current = sections[0].id;
      sections.forEach((section) => {
        const el = document.getElementById(section.id);
        if (el && window.scrollY >= el.offsetTop - 100) {
          current = section.id;
        }
      });
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // скролл к секции
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({
        top: el.offsetTop - 100,
        behavior: "smooth",
      });
      setIsOpen(false); // закрываем бургер после клика
    }
  };

  return (
    <nav className="navbar">
      {/* бургер */}
      <div className="burger" onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* меню */}
      <ul className={`menu ${isOpen ? "open" : ""}`}>
        {sections.map((section) => (
          <li key={section.id}>
            <a
              onClick={() => scrollToSection(section.id)}
              className={activeSection === section.id ? "active" : ""}
            >
              {t(section.key)}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
